// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.
//
// Timeline strip maths and text, no DOM. Mirrors the Ruby side of
// rui_chart(type: :timeline_strip) (Chart::TimelineStrip: #percent, #segment_box,
// #days, #span_text, #year_ticks, #show_tick_label?), and
// test/javascript/chart_timeline_strip.test.mjs checks both agree on
// test/javascript/fixtures/timeline_strip.json. Dates are whole days since the
// epoch (UTC), so no time zone can shift a bar.

const DAY_MS = 86400000
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const MAX_AXIS_LABELS = 8

// "2019-03-04" (or anything starting with an ISO date) to a day number.
export function dayOf(iso) {
  const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number)
  return Math.round(Date.UTC(y, m - 1, d) / DAY_MS)
}

export function isoOf(day) {
  return new Date(day * DAY_MS).toISOString().slice(0, 10)
}

const round3 = (x) => Math.round(x * 1000) / 1000

// Percent of the axis for a day, clamped to the domain.
export function percentOf(day, from, to) {
  const span = Math.max(to - from, 1)
  return Math.min(Math.max(round3((day - from) / span * 100), 0), 100)
}

// Left and width (percent) of a period; an open period (to null) runs to the domain end.
export function segmentBox(from, to, domain) {
  const left = percentOf(from, domain.from, domain.to)
  const right = percentOf(to ?? domain.to, domain.from, domain.to)
  return { left, width: Math.max(round3(right - left), 0) }
}

export function daysBetween(from, to) {
  return Math.max(to - from, 0)
}

// Ruby's "%b %-d, %Y".
export function formatDate(day) {
  const d = new Date(day * DAY_MS)
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`
}

export function daysText(n) {
  return n === 1 ? "1 day" : `${delimited(n)} days`
}

// "since Mar 4, 2019, 2,780 days" while open; "May 20, 2015 to Jan 10, 2018, 966 days" when closed.
export function spanText(from, to, today) {
  const open = to === null || to === undefined
  const n = daysText(daysBetween(from, open ? today : to))
  return open ? `since ${formatDate(from)}, ${n}` : `${formatDate(from)} to ${formatDate(to)}, ${n}`
}

// January 1 of every year inside the domain, as { year, day }.
export function yearTicks(from, to) {
  const first = new Date(from * DAY_MS).getUTCFullYear()
  const last = new Date(to * DAY_MS).getUTCFullYear()
  const ticks = []
  for (let y = first; y <= last; y++) {
    const day = Math.round(Date.UTC(y, 0, 1) / DAY_MS)
    if (day >= from && day <= to) ticks.push({ year: y, day })
  }
  return ticks
}

export function tickStep(count, every = null) {
  return every || Math.max(Math.ceil(count / MAX_AXIS_LABELS), 1)
}

// First and last always; every nth otherwise, never one right before the last.
export function showTick(i, count, step) {
  const last = count - 1
  if (i === 0 || i === last) return true
  return i % step === 0 && last - i >= step
}

function delimited(n) {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
